// extracted by mini-css-extract-plugin
export default {"control":"Cible_control__gRet5","wrapper":"Cible_wrapper__Qqnqm","confirm":"Cible_confirm__YcRJ5","price":"Cible_price__wAdB1"};